export default __webpack_public_path__ + "static/media/scene_12.7b5effbd.png";